import styled from 'styled-components'

export const CsatDesktop = styled.div`
  display: flex;
  flex-direction: row;
  gap: 3px;
  overflow-x: auto;

  @media (max-width: 600px) {
    display: none !important;
  }
`

export const CsatMobile = styled.div`
  display: none;
  flex-direction: column;
  gap: 3px;

  @media (max-width: 600px) {
    display: flex !important;
  }
`
